import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:namespace/functions',
    name: 'Functions',
    component: () => import(/* webpackChunkName: "functions" */ '../views/Functions.vue')
  },
  {
    path: '/:namespace/functions/:name',
    name: 'Function',
    component: () => import(/* webpackChunkName: "functions" */ '../views/Functions.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  if (to.params.namespace !== undefined) {
    (router.app.$store as any).dispatch('namespaces/selectCurrent', to.params.namespace)
  }
})

export default router
